import { render } from "./SortedSelect2.vue?vue&type=template&id=75593bf6"
import script from "./SortedSelect2.vue?vue&type=script&lang=js"
export * from "./SortedSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__